module.exports = __webpack_public_path__ + "img/k-bg2.17844278.png";